/**
 * 個人レポート v2 のモバイル埋め込みページ。
 *
 * ・PersonalReportMeEmbedPage   … /embed/report/me（本人。モバイルの「個人レポート」）
 * ・PersonalReportUserEmbedPage … /embed/report/employee/:userId（社長が社員のものを見る）
 *
 * 取得は usePersonalReportV2Data、描画は Gb74PersonalReportMobile に任せる。
 * 算出・文言はPC（PDF）と同じモジュールなので、内容は一致する。
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import {
  usePersonalReportV2Data,
  type PersonalReportTarget,
} from '../hooks/usePersonalReportV2Data';
import { Gb74PersonalReportMobile } from './Gb74PersonalReportMobile';

const msgStyle: React.CSSProperties = {
  fontFamily: '"Hiragino Sans", "Hiragino Kaku Gothic ProN", "Yu Gothic", Meiryo, sans-serif',
  padding: 24,
  color: '#6b7280',
  fontSize: 13,
  lineHeight: 1.8,
  textAlign: 'center',
};

const PersonalReportEmbed: React.FC<{ target: PersonalReportTarget }> = ({ target }) => {
  const { data, loading, error } = usePersonalReportV2Data(target);

  if (loading) return <div style={msgStyle}>読み込み中…</div>;
  if (error || !data)
    return <div style={msgStyle}>{error ?? 'レポートを表示できませんでした。'}</div>;

  return (
    <Gb74PersonalReportMobile
      report={data.report}
      texts={data.texts}
      userName={data.userName}
      answerDate={data.answerDate}
      departmentName={data.departmentName}
    />
  );
};

/** 本人のレポート。 */
export const PersonalReportMeEmbedPage: React.FC = () => (
  <PersonalReportEmbed target={{ kind: 'me' }} />
);

/** 社員のレポート（社長がモバイルの社員一覧から開く）。 */
export const PersonalReportUserEmbedPage: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();
  return <PersonalReportEmbed target={{ kind: 'user', userId: userId ?? '' }} />;
};
